import type { ReactElement } from "react";
import appletsData from "../../data/pages/octant-applets.json";
import type { OctantParentPageTemplate } from "../../services/octant/octantPageService";
import FlipCardGrid from "../../components/FlipCardGrid";
import OctantPage from "./OctantPage";

const TEMPLATE = appletsData as OctantParentPageTemplate;

export default function OctantAppletsPage(): ReactElement {
  return (
    <OctantPage
      pageId="octant"
      template={TEMPLATE}
      capabilitiesRenderer={(section) => (
        <FlipCardGrid title={section.title} cards={section.cards} />
      )}
    />
  );
}
